import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-3xl text-foreground-400">
        <i className="ri-ghost-line" />
      </span>
      <p className="mt-6 font-heading text-5xl font-bold text-primary-500">404</p>
      <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">这一页找不到瓜</h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的页面可能已经调整或下线了，不妨回首页看看现在大家都在讨论什么。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/topics"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览话题广场
        </Link>
      </div>
    </div>
  );
}